import { memo } from "react";

import { ToolbarButton } from "components/base";
import { LegendFilled } from "components/icons";
import { useChartSettings } from "components/multiphase-chart/context";
import { changeLegend } from "components/multiphase-chart/context/reducer/chartSettingsReducer";

const LegendToggle = () => {
  const [chartSettings, chartSettingsDispatch] = useChartSettings();
  const { legend } = chartSettings;

  const onToggleHandle = () => {
    const nextSettings = { ...legend, visible: !legend.visible };
    changeLegend(chartSettingsDispatch, nextSettings);
  };

  return (
    <ToolbarButton
      testId="multiphasechart-toolbar-legend-toggle"
      active={legend.visible}
      icon={<LegendFilled style={{ width: "30px", height: "30px" }} />}
      onToggle={onToggleHandle}
      overflowLabel="Legend"
      tooltipText="Legend"
    />
  );
};

export default memo(LegendToggle);
